(function () {
  if (window.__sizeGuideInit) return;
  window.__sizeGuideInit = true;

  function parse(el, name) {
    try {
      return JSON.parse(el.getAttribute(name) || '{}');
    } catch (e) {
      return {};
    }
  }

  function sync(root, variantId) {
    var tags = parse(root, 'data-variant-tags');
    var urls = parse(root, 'data-chart-urls');
    var tag = tags[String(variantId)] || '';
    var img = root.querySelector('.size-guide__image');
    if (!img) return;
    if (!tag || !urls[tag]) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    img.src = urls[tag];
    img.removeAttribute('srcset');
  }

  document.querySelectorAll('[data-size-guide]').forEach(function (root) {
    var initial = new URLSearchParams(location.search).get('variant');
    if (initial) sync(root, initial);
  });

  document.addEventListener('variant:change', function (e) {
    var id = e.detail && e.detail.variant && e.detail.variant.id;
    if (!id) return;
    document.querySelectorAll('[data-size-guide]').forEach(function (root) {
      sync(root, id);
    });
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'id') return;
    document.querySelectorAll('[data-size-guide]').forEach(function (root) {
      sync(root, t.value);
    });
  });
})();
